export const fonts = {
  manrope: "Manrope",
  inter: "Inter",
};
